let iframe;
let iframeWindow;
let iframeDocument;

function ensureSandbox() {
  if (typeof document === 'undefined') {
    throw new Error('Sandbox not available');
  }

  if (!iframe || !iframe.isConnected || !iframe.contentWindow) {
    iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    const host = document.body || document.documentElement;
    if (!host) {
      throw new Error('Sandbox host not available');
    }
    host.appendChild(iframe);
  }

  iframeWindow = iframe.contentWindow;
  iframeDocument = iframe.contentDocument || iframeWindow.document;
}

function resetSandbox() {
  iframeDocument.open();
  iframeDocument.write("<script>window = undefined; document = undefined; alert = undefined; console = undefined;<\\/script>");
  iframeDocument.close();
}

function evaluateFormula(formula, args) {
  ensureSandbox();
  resetSandbox();

  const argsString = Array.isArray(args)
    ? args.join(',')
    : (args === undefined || args === null ? '' : String(args));
  const invocation = argsString ? `(${formula})(${argsString})` : `(${formula})()`;
  return iframeWindow.eval(invocation);
}

module.exports = {
  evaluateFormula
};
